import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";
import CongraContentSection from "../sections/congra/CongraContentSection.jsx";

function CongraPage() {
  return (
    <PrimaryPageContainer>
      <CongraContentSection />
    </PrimaryPageContainer>
  );
}

export default CongraPage;
